const fields = [
  {
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'title',
    key: 'title',
    title: '文章标题',
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'publishingDate',
    key: 'publishingDate',
    title: '发布时间',
    width: 120
  },
  {
    dataIndex: 'statusStr',
    key: 'status',
    width: 90,
    scopedSlots: {
      customRender: 'color'
    },
    title: '状态'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 9,
    label: '文章标题',
    component: 'AInput',
    placeholder: '请输入文章标题',
    prop: 'title',
    allowClear: true
  },
  {
    span: 3,
    label: '文章标题',
    component: 'AInput',
    placeholder: '请输入文章标题',
    prop: 'title1',
    allowClear: true,
    show:false
  },
  {
    span: 3,
    component: 'OtherButton',
    btName: '清空条件',
    cb: 'clearAll'
  },
  {
    span: 2,
    component: 'OtherButton',
    btName: '搜索',
    cb: 'toSearch',
    customButtonItemStyle: {
      color: '#fff',
      border: '0px',
      background: 'linear-gradient(0deg, #2087FB, #73D3FF)'
    }
  }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [{
        name: '编辑',
        cb: 'edit'
      },
      // { name: '发布', cb: 'issue', divider: true },
      {
        name: '删除',
        cb: 'singleDelete',
        divider: true
      }
    ]
  }
]

module.exports = {
  fields,
  slotOpt,
  formRow
}
